module.exports = __webpack_public_path__ + "img/icon_map_1_5_yj.6e5eb1f2.png";